import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

const TONES = {
  primary: { tile: 'bg-primary bg-opacity-5', value: 'text-primary', icon: 'bg-primary' },
  success: { tile: 'bg-success bg-opacity-5', value: 'text-success', icon: 'bg-success' },
  warning: { tile: 'bg-orange-500 bg-opacity-5', value: 'text-orange-500', icon: 'bg-orange-500' },
  neutral: { tile: 'bg-body-text bg-opacity-5', value: 'text-body-text', icon: 'bg-body-text' }
}

function Tile({ icon: Icon, label, value, percent, hint, tone = 'primary' }) {
  const { tile, value: valueColor, icon: iconBg } = TONES[tone] || TONES.primary

  return (
    <div className={`w-full rounded-2xl p-4 ${tile}`}>
      <div className="flex items-start justify-between mb-1">
        <p className="text-sm text-secondary">{label}</p>

        {
          Icon && (
            <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${iconBg}`}>
              <Icon size={18} className="text-white" />
            </div>
          )
        }
      </div>

      <div className={`flex items-center gap-2 ${valueColor}`}>
        <p className="text-xl font-bold">{value}</p>
        {percent != null && <p className="text-sm opacity-70">{percent}%</p>}
      </div>

      {hint && <p className="text-xs text-secondary mt-1">{hint}</p>}
    </div>
  )
}

export default withTranslation()(function RewardAdsStats({ t, campaigns = [] }) {
  const total = campaigns.length
  const countByStatus = (status) => campaigns.filter((campaign) => campaign.status === status).length
  const percentOf = (count) => (total ? Math.round((count / total) * 100) : 0)

  const active = countByStatus('active')
  const scheduled = countByStatus('scheduled')
  const completed = countByStatus('completed')

  return (
    <div className="grid gap-4 md:grid-cols-4 mb-5">
      <Tile
        icon={UIcons.UilChart}
        label={t('rewardAds.stats.total')}
        value={total}
        hint={t('rewardAds.stats.total_hint')}
        tone="primary"
      />
      <Tile
        icon={UIcons.UilSync}
        label={t('rewardAds.stats.active')}
        value={active}
        percent={percentOf(active)}
        hint={t('rewardAds.stats.active_hint')}
        tone="success"
      />
      <Tile
        icon={UIcons.UilCalendarAlt}
        label={t('rewardAds.stats.scheduled')}
        value={scheduled}
        percent={percentOf(scheduled)}
        hint={t('rewardAds.stats.scheduled_hint')}
        tone="warning"
      />
      <Tile
        icon={UIcons.UilCheck}
        label={t('rewardAds.stats.completed')}
        value={completed}
        percent={percentOf(completed)}
        hint={t('rewardAds.stats.completed_hint')}
        tone="neutral"
      />
    </div>
  )
})
